export type FeedbackRate = 'like' | 'dislike';

export enum FeedbackType {
  NA,
  Positive = 5,
  Negative = 10,
}
